import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  InputGroup,
  Input,
  Select,
  FormGroup
} from 'reactstrap'

class FieldCheckbox extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedField: this.props.cardField.fieldValue || (this.props.cardField.fieldValues ? [] : false)
    }

    this.returnValue = this.returnValue.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
  }

  returnValue() {
    return this.state.selectedField
  }

  handleSelectChange(ev) {
    let checkbox = ev.target
    this.setState(prevState => {
      let selectedField = []

      if (!checkbox.checked) {
        selectedField = this.props.cardField.fieldValues ? prevState.selectedField.filter(el => el !== checkbox.value) : false
      } else {
        selectedField = this.props.cardField.fieldValues ? prevState.selectedField.concat(checkbox.value) : true
      }

      return {
        selectedField
      }
    })
  }

  render() {
    const fieldClassName = `card-field field-checkbox ${this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : ''}`

    if (this.props.cardField.fieldValues) {
      return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
        <Label className="d-sm-block">{this.props.cardField.fieldLabel}</Label>
        <InputGroup key={`input-${this.props.cardField.id}`} className="mb-3 d-sm-block">
          {this.props.cardField.fieldValues.map(checkboxOption => {
            let checkboxKey = Object.keys(checkboxOption)[0]
            let checkboxValue = Object.values(checkboxOption)[0]
            let checked = this.props.cardField.fieldValue.filter(el => el === checkboxKey)

            return (
              <Label key={`checkbox-${checkboxKey}`} className="d-sm-block ml-4">
                <Input
                  type={this.props.cardField.fieldType}
                  key={this.props.cardField.id}
                  name={this.props.cardField.id}
                  value={checkboxKey}
                  defaultChecked={checked.length > 0}
                  onChange={this.handleSelectChange}
                  innerRef={el => { this[this.props.cardField.id] = el }}
                />{' '}
                {checkboxValue}
              </Label>
            )
          })}
        </InputGroup>
      </div> : <div className={fieldClassName}>
        <Label className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
        <div className="mb-3">
          {this.props.cardField.fieldValues
            .filter(el => this.props.cardField.fieldValue.indexOf(Object.keys(el)[0]) > -1)
            .map((checkboxOption, index) => {
              return <div key={`checkbox-${this.props.cardField.id}-${index}`} className="mb-1"><i className="icon-check"></i> {Object.values(checkboxOption)[0]}</div>
            })
          }
        </div>
      </div>
    } else {
      return this.props.isEditing || this.props.cardType === 'always-on' ? <div className={fieldClassName}>
        <Label key={`label-${this.props.cardField.id}`} className="d-sm-block">{this.props.cardField.fieldLabel}</Label>
        <InputGroup key={`input-${this.props.cardField.id}`} className="mb-3 d-sm-block">
          <Label className="d-sm-block ml-4">
            <Input
              type={this.props.cardField.fieldType}
              key={this.props.cardField.id}
              name={this.props.cardField.id}
              value={this.props.cardField.fieldValue}
              defaultChecked={this.props.cardField.fieldValue}
              onChange={this.handleSelectChange}
              innerRef={el => { this[this.props.cardField.id] = el }}
            />{' '}
            {this.props.cardField.fieldValueLabel.true}
          </Label>
        </InputGroup>
      </div> : <div className={fieldClassName}>
        <Label className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
        <div className="mb-3">
          <div key={`checkbox-${this.props.cardField.id}`} className="mb-1">
            {this.props.cardField.fieldValueLabel[this.state.selectedField.toString()]}
          </div>
        </div>
      </div>
    }
  }
}

FieldCheckbox.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldCheckbox.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldCheckbox


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldCheckbox.js